import React from "react";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const ComparisonChart = ({ data, dataKeys, colors }) => {
    const labelMap = {
        period1: "Periodo 1",
        period2: "Periodo 2",
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div
                    style={{
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: "15px",
                        padding: "1em",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                        fontSize: "12px",
                        color: "#394F65",
                    }}
                >
                    <p style={{ margin: 0, fontWeight: 600 }}>{label}.</p>
                    {payload.map((entry, index) => (
                        <p key={`item-${index}`} style={{ margin: 0, color: entry.color }}>
                            {`${labelMap[entry.name] || entry.name}: ${entry.value.toLocaleString()} $`}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    const CustomDot = ({ cx, cy, fill }) => (
        <g>
            <circle cx={cx} cy={cy} r={10} fill={fill} opacity={0.2} />
            <circle cx={cx} cy={cy} r={6} fill={fill} opacity={0.4} />
            <circle cx={cx} cy={cy} r={4} fill={fill} stroke="#fff" strokeWidth={2} />
        </g>
    );

    return (
        <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                <defs>
                    {dataKeys.map((key, index) => (
                        <linearGradient key={key} id={`color${key}`} x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={colors[index]} stopOpacity={0.4} />
                            <stop offset="95%" stopColor={colors[index]} stopOpacity={0} />
                        </linearGradient>
                    ))}
                </defs>

                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />

                <XAxis
                    dataKey="name"
                    stroke="rgba(0, 0, 0, 0.40)"
                    padding={{ left: 30, right: 30 }}
                    tick={{
                        fill: "rgba(0, 0, 0, 0.40)",
                        fontSize: "15px",
                        fontWeight: 400,
                    }}
                />
                <YAxis
                    stroke="rgba(0, 0, 0, 0.40)"
                    tickFormatter={(value) => `${value / 1000}K`}
                    tick={{
                        fill: "rgba(0, 0, 0, 0.40)",
                        fontSize: "15px",
                        fontWeight: 400,
                    }}
                />

                <Tooltip content={<CustomTooltip />} />

                {dataKeys.map((key, index) => (
                    <Area
                        key={key}
                        type="monotone"
                        dataKey={key}
                        stroke={colors[index]}
                        fillOpacity={1}
                        fill={`url(#color${key})`}
                        dot={<CustomDot fill={colors[index]} />}
                        activeDot={<CustomDot fill={colors[index]} />}
                    />
                ))}
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default ComparisonChart;
